<div class="tooltip"
     [style.left]="left + 'px'" [style.top]="top + 'px'" [innerHTML]="tooltip">
</div>
